import type { SignedDocument } from "store/articleStore";

export const typeLabel = (doc: SignedDocument, t: (key: string) => string): string =>
    doc.type === "avenant" ? t("BPTitle.DocumentTypeAvenant") : t("BPTitle.DocumentTypeAgreement");

export const buildDisplayName = (doc: SignedDocument): string => doc.articleName || doc.titleName || "-";
